export default __webpack_public_path__ + "static/media/game-example.28bc8e61.png";